import { Feature } from '../types/pricingPage';
import { v4 as uuid } from 'uuid';

export enum UserPlan {
    LAUNCHER = 'Launcher', // Free Plan
    STARTUP = 'Startup',
    BOOTSTRAPPER = 'Bootstrapper',
    SCALE_UP = 'Scale Up',
    STARTUP_OLD = 'Startup Plan',
}

export const PAID_PLANS = [UserPlan.STARTUP, UserPlan.BOOTSTRAPPER, UserPlan.SCALE_UP, UserPlan.STARTUP_OLD];

export const PRO_PLANS = [UserPlan.SCALE_UP];

export const isPaidPlan = (plan: UserPlan): boolean => PAID_PLANS.includes(plan);

export const sortFeatures = (feature1: Feature, feature2: Feature) =>
    (feature1.order ?? 0) > (feature2.order ?? 0) ? 1 : -1;

export const newFeature = (index: number, name: string = ''): Feature => ({
    id: uuid(),
    name,
    allPlans: false,
    visible: true,
    subdued: false,
    slug: '',
    order: index,
});
